import { AdminOrganisationRoutes } from "./organisation.routes";
import { AdminUsersRoutes } from "./users.routes";

export const AdminRoutes = [...AdminOrganisationRoutes, ...AdminUsersRoutes];
